export default {
    'query.queryCard.h1':'Global trade & logistic query platform',
    'query.queryCard.p':'DawnTron Logistics Query System tracks trade & logistic information in the whole process, plan ahead and set checkpoints, closely track and update checkpoints status. The overall OTD ratio is above 99%.',
    'query.queryCard.placeholder':'Please enter the order number',
    'query.queryCard.submit':'submit',
    'query.stepsCard.item01.title':'Accurate tracking',
    'query.stepsCard.item01.desc':'Full process multi-channel real-time positioning query',
    'query.stepsCard.item02.title':'Efficient customs',
    'query.stepsCard.item02.desc':'Multi port customs clearance is extremely efficient',
    'query.stepsCard.item03.title':'Exclusive service',
    'query.stepsCard.item03.desc':'Priority in warehouse, top trade & logistic service provider',
    'query.stepsCard.item04.title':'Quality assurance',
    'query.stepsCard.item04.desc':'Common goods ONLY, safe and stable',
    'query.stepsCard.item05.title':'Top trade & logistic',
    'query.stepsCard.item05.desc':'Top trade & logistic service provider, more comfortable for final delivery',
}